export const getFilteredJobs = (data, title, workType, state) => {
  let result = data;

  // Filter by title (if provided)
  if (title) {
    result = result?.filter((eachJob) =>
      eachJob?.jobTitle?.toLowerCase().includes(title.toLowerCase())
    );
  }

  // Filter by workType (if provided)
  if (workType) {
    result = result?.filter((eachJob) =>
      eachJob?.workType?.toLowerCase().includes(workType?.toLowerCase())
    );
  }

  // Filter by state (if provided)
  if (state) {
    result = result?.filter(
      (eachJob) => eachJob?.state?.toLowerCase() === state.toLowerCase()
    );
  }

  return result;
};

export const getSimilarJobs = (data, jobDetails) => {
  const jobData = data?.filter(
    (eachJob) =>
      eachJob?.jobTitle?.toLowerCase() ===
        jobDetails?.jobTitle?.toLowerCase() && eachJob?._id !== jobDetails?._id
  );
  return jobData?.length === 0 ? data?.slice(0, 3) : jobData;
};
